export const WITHDRAWAL_WHITELIST = '/api/v1/user/crypto/whitelist';
export const WITHDRAWAL_WHITELIST_EXPRESS =
  '/api/v1/user/crypto/whitelist/express';
export const NETWORKS = '/api/v1/wallet/networks';

/**
 * The toman rail. It is a network row like any other, but it is where a bank
 * transfer goes, not a wallet address, and it has no address rule at all — so
 * it is never offered as a crypto destination.
 */
export const NON_CRYPTO_NETWORKS = ['SHETAB'];
export const WITHDRAW_INIT_WHITELIST = `/api/v1/financial-coordinator/crypto/withdraw/init/whitelist`;
export const WITHDRAW_WHITELIST_EXPRESS = `/api/v1/financial-coordinator/crypto/withdraw/whitelist/express`;

// A label of exactly 200 characters is rejected by user-management, so the
// real maximum is below it. Until the backend gives us the exact number this
// only stops the obviously-too-long ones; 10002 stays the authority.
export const WHITELIST_LABEL_MAX_LENGTH = 199;

// Application error codes this feature reacts to. Everything else falls
// through to the global snackbar in rtkQueryErrorLogger.
export const WHITELIST_ERROR = {
  /** Invalid input — empty address, over-long label, malformed id. */
  INVALID_INPUT: 10002,
  /** The address does not pass the network's own validation. */
  INVALID_ADDRESS: 10012,
  /** Express is disabled right now; the token's claim was stale. */
  EXPRESS_DISABLED: 10073,
  /** Entry missing, not yours, deleted, or on another network — one answer for all four. */
  ENTRY_UNAVAILABLE: 10075,
  /** The same (network, address, memo) is already registered and active. */
  DUPLICATE_ENTRY: 10076,
  /** A memo was sent for a network that has none. */
  MEMO_NOT_SUPPORTED: 10077,
  /** The memo does not match the network's memo pattern. */
  INVALID_MEMO: 10078,
  /** The network is unknown to wallet. */
  UNKNOWN_NETWORK: 10079
} as const;
